export default __webpack_public_path__ + "static/media/MultipleUsers.70696013.svg";